import type { GroupingElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './GroupingElement'
import type { GroupingDemoType } from './groupingTypes'

const imageValue = {
  source: FileUsageSource.file,
  id: '',
  accessibility: '',
}

const DEMO_VALUE: GroupingElementValue = {
  items: [
    {
      value: 'grouping_group_1',
      target: {
        label: t('elements.grouping.value.firstLabel'),
        image: imageValue,
        overlay: null,
      },
      items: [
        {
          value: 'grouping_group1_item_1',
          label: t('elements.grouping.value.firstItem', {
            elem: t('elements.grouping.value.firstElem'),
          }),
          image: imageValue,
          overlay: null,
        },
        {
          value: 'grouping_group1_item_2',
          label: t('elements.grouping.value.firstItem', {
            elem: t('elements.grouping.value.secondElem'),
          }),
          image: imageValue,
          overlay: null,
        },
        {
          value: 'grouping_group1_item_3',
          label: t('elements.grouping.value.firstItem', {
            elem: t('elements.grouping.value.thirdElem'),
          }),
          image: imageValue,
          overlay: null,
        },
      ],
    },
    {
      value: 'grouping_group_2',
      target: {
        label: t('elements.grouping.value.secondLabel'),
        image: imageValue,
        overlay: null,
      },
      items: [
        {
          value: 'grouping_group2_item_1',
          label: t('elements.grouping.value.secondItem', {
            elem: t('elements.grouping.value.firstElem'),
          }),
          image: imageValue,
          overlay: null,
        },
        {
          value: 'grouping_group2_item_2',
          label: t('elements.grouping.value.secondItem', {
            elem: t('elements.grouping.value.secondElem'),
          }),
          image: imageValue,
          overlay: null,
        },
        {
          value: 'grouping_group2_item_3',
          label: t('elements.grouping.value.secondItem', {
            elem: t('elements.grouping.value.thirdElem'),
          }),
          image: imageValue,
          overlay: null,
        },
      ],
    },
  ],
}

const GroupingDemo: GroupingDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.grouping.type}-demo`,
        type: CONFIG_ELEMENTS.grouping.type,
        value: DEMO_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default GroupingDemo
